import React from "react";
import {Button, Tooltip} from "antd";
import {useAreChangesMadeToDesign} from "../../../../../../../hooks/useAreChangesMadeToDesign";
import {CertificateIcon} from "@phosphor-icons/react";
import {setPathname} from "../../../../../../../helpers/storeHelpers";
import {useViewerStore} from "../../../../../../../store/store";

const EngineeringAffidavitButton : React.FC = () => {

    const { areChangesMade, isOriginalSite } = useAreChangesMadeToDesign();
    const setIsSidebar = (val: boolean) => useViewerStore.setState({isLeftSidebarOpen: val});


    const onClickEngAffidavit = () => {
        setPathname("/configure/building/engineering-affidavit");
        setIsSidebar(false);

    }

    return(
        <>
                <Tooltip title={areChangesMade ? "Changes were made. Finalize before downloading."
                    : isOriginalSite
                        ? "Feature disabled for the Original design. Select a finalized design."
                        : ""}>
                    <Button
                        disabled={areChangesMade || isOriginalSite}
                        icon={<CertificateIcon  size={20}/>}
                        type='primary' size='large' block onClick={onClickEngAffidavit}>
                        Final Engineering Affidavit
                    </Button>
                </Tooltip>
        </>
    )
}

export default EngineeringAffidavitButton;